import { ConsultaSeguimentoIndicatorResultadoText } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoIndicatorResultado'
import { PassouFalhouEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { hasAnySim, isAllFilled, isAllNao } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'

import {
  ConsultaSeguimentoPergunta11ExemplosEnum,
  ConsultaSeguimentoPergunta11Model,
} from './model-consultaSeguimentoPergunta11'

const pergunta11ExemplosPassouEnumValues = [
  ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_SORRI,
  ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_ENTRA_NO_QUARTO,
  ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_VOLTA,
]
const pergunta11ExemplosFalhouEnumValues = [
  ConsultaSeguimentoPergunta11ExemplosEnum.ESTA_SEMPRE_SORRINDO,
  ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_PARA_BRINQUEDO_OU_ATIVIDADE,
  ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_AO_ACASO_OU_SEM_MOTIVO,
]

export function isPergunta11ExemplosAllFilled(
  value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']
): boolean {
  return (
    isAllFilled(value?.PASSOU, pergunta11ExemplosPassouEnumValues) &&
    isAllFilled(value?.FALHOU, pergunta11ExemplosFalhouEnumValues)
  )
}

export function isPergunta11ExemplosAllNao(value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']): boolean {
  return (
    isAllNao(value?.PASSOU, pergunta11ExemplosPassouEnumValues) &&
    isAllNao(value?.FALHOU, pergunta11ExemplosFalhouEnumValues)
  )
}

export function isPergunta11ExemplosPassouAllNao(
  value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']
): boolean {
  return isAllNao(value?.PASSOU, pergunta11ExemplosPassouEnumValues)
}

export function isPergunta11ExemplosFalhouAllNao(
  value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']
): boolean {
  return isAllNao(value?.FALHOU, pergunta11ExemplosFalhouEnumValues)
}

export function hasPergunta11ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']
): boolean {
  return hasAnySim(value?.PASSOU)
}

export function hasPergunta11ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']
): boolean {
  return hasAnySim(value?.FALHOU)
}

export function getPergunta11ResultadoText(
  value: ConsultaSeguimentoPergunta11Model
): ConsultaSeguimentoIndicatorResultadoText {
  const isExemplosAllNao = isPergunta11ExemplosAllNao(value?.PERGUNTA_11_EXEMPLOS)
  const isPassouAllNao = isPergunta11ExemplosPassouAllNao(value?.PERGUNTA_11_EXEMPLOS)
  const isFalhouAllNao = isPergunta11ExemplosFalhouAllNao(value?.PERGUNTA_11_EXEMPLOS)
  const hasPassouAnySim = hasPergunta11ExemplosPassouAnySim(value?.PERGUNTA_11_EXEMPLOS)
  const hasFalhouAnySim = hasPergunta11ExemplosFalhouAnySim(value?.PERGUNTA_11_EXEMPLOS)
  const isSimSomentePassou = hasPassouAnySim && isFalhouAllNao
  const isSimSomenteFalhou = hasFalhouAnySim && isPassouAllNao

  const textResultadoPassouByFrequencia =
    value?.PERGUNTA_11_FREQUENCIA === PassouFalhouEnum.PASSOU ? 'Os mais frequentes são exemplos de Passou:' : ''

  const textResultadoFalhouByFrequencia =
    value?.PERGUNTA_11_FREQUENCIA === PassouFalhouEnum.FALHOU ? 'Os mais frequentes são exemplos de Falhou:' : ''

  const textResultadoFalhouByAllExemplosNao = isExemplosAllNao ? 'Não para todos' : textResultadoFalhouByFrequencia

  const textResultadoPassou = isSimSomentePassou ? 'Sim somente para exemplos Passou:' : textResultadoPassouByFrequencia

  const textResultadoFalhou = isSimSomenteFalhou
    ? 'Sim somente para exemplos FALHOU:'
    : textResultadoFalhouByAllExemplosNao

  return {
    FALHOU: textResultadoFalhou,
    PASSOU: textResultadoPassou,
  }
}

export function prunePergunta11(value: ConsultaSeguimentoPergunta11Model): ConsultaSeguimentoPergunta11Model {
  const pruned: ConsultaSeguimentoPergunta11Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_11_HEADER: value.PERGUNTA_11_HEADER,
  }

  const isHeaderNao = value.PERGUNTA_11_HEADER === SimNaoEnum.NAO
  const hasPerguntaExemplosPassouAnySim = hasPergunta11ExemplosPassouAnySim(value.PERGUNTA_11_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta11ExemplosFalhouAnySim(value.PERGUNTA_11_EXEMPLOS)

  if (isHeaderNao) {
    pruned.PERGUNTA_11_EXEMPLOS = value.PERGUNTA_11_EXEMPLOS
  }

  if (isHeaderNao && hasPerguntaExemplosPassouAnySim && hasPerguntaExemplosFalhouAnySim) {
    pruned.PERGUNTA_11_FREQUENCIA = value.PERGUNTA_11_FREQUENCIA
  }

  return pruned
}

export function conditionToCalculatePergunta11(values: ConsultaSeguimentoPergunta11Model): boolean {
  if (values?.PERGUNTA_11_HEADER === SimNaoEnum.SIM) {
    return true
  }

  if (
    !isPergunta11ExemplosAllFilled(values?.PERGUNTA_11_EXEMPLOS) ||
    isPergunta11ExemplosAllNao(values.PERGUNTA_11_EXEMPLOS)
  ) {
    return false
  }

  const hasPassouAnySim = hasPergunta11ExemplosPassouAnySim(values?.PERGUNTA_11_EXEMPLOS)
  const hasFalhouAnySim = hasPergunta11ExemplosFalhouAnySim(values?.PERGUNTA_11_EXEMPLOS)

  if ((hasPassouAnySim && !hasFalhouAnySim) || (hasFalhouAnySim && !hasPassouAnySim)) {
    return true
  } else {
    return !isEmpty(values?.PERGUNTA_11_FREQUENCIA)
  }
}

export function calculateResultadoPergunta11(values: ConsultaSeguimentoPergunta11Model): PassouFalhouEnum | undefined {
  if (values?.PERGUNTA_11_HEADER === SimNaoEnum.SIM) {
    return PassouFalhouEnum.PASSOU
  } else {
    const isPassouAllNao = isPergunta11ExemplosPassouAllNao(values?.PERGUNTA_11_EXEMPLOS)
    const isFalhouAllNao = isPergunta11ExemplosFalhouAllNao(values?.PERGUNTA_11_EXEMPLOS)
    const isExemplosAllNao = isPergunta11ExemplosAllNao(values?.PERGUNTA_11_EXEMPLOS)
    const hasPassouAnySim = hasPergunta11ExemplosPassouAnySim(values?.PERGUNTA_11_EXEMPLOS)
    const hasFalhouAnySim = hasPergunta11ExemplosFalhouAnySim(values?.PERGUNTA_11_EXEMPLOS)

    if (hasPassouAnySim && isFalhouAllNao) {
      return PassouFalhouEnum.PASSOU
    }

    if ((hasFalhouAnySim && isPassouAllNao) || isExemplosAllNao) {
      return PassouFalhouEnum.FALHOU
    }

    if (isPergunta11ExemplosAllFilled(values?.PERGUNTA_11_EXEMPLOS)) {
      return values?.PERGUNTA_11_FREQUENCIA
    }
  }
}
